import React, { useContext, useEffect, useState } from "react";
// Soft UI Dashboard PRO React example components
import { useNavigate } from "react-router-dom";

import SuiButton from "components/SuiButton";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import Skeleton from "@mui/material/Skeleton";

import { StoreContext } from "context/store";
import { AccountContext } from "context/account";
import CategoryContext from "context/category-context";

import AddProductCard from "pages/de/portfolio/components/AddProductCard";
import ProductCard from "pages/de/portfolio/components/ProductCard";

import Gallery from "pages/de/portfolio/components/Gallery";
import Profile from "pages/de/portfolio/components/Profile";

import api from "services/api";

import toast from "react-hot-toast";
import SortableList, { SortableItem } from "react-easy-sort";

const Template1 = ({
  handle,
  handleClickProduct,
  handleRefresh,
  handleOk,
  onSortEnd,
  handleImportCollection,
  handleShowImportCollection,
  handleClickItem,
  userData,
}) => {
  const { store } = useContext(StoreContext);
  const account = useContext(AccountContext);

  let portfolioData = account?.metadata?.portfolio_content || {};
  let storeData = store;
  if (handle) {
    portfolioData = userData?.metadata?.portfolio_content || {};
    storeData = userData?.stores?.[0] || {};
  }
  let collectionStyleList = portfolioData["col_0"] || [];
  let featuredStyleList = portfolioData["style_0"] || [];

  return (
    <div>
      <Grid container columnSpacing={3}>
        <Grid item xs={12} sm={5} md={5} lg={4} xl={3} wrap={"wrap-reverse"}>
          {handle && featuredStyleList.length == 0 ? null : (
            <SuiBox>
              <SuiBox my={2}>
                <SuiTypography variant="h5" fontWeight="medium" textTransform="capitalize">
                  Featured Styles
                </SuiTypography>
              </SuiBox>
              <SuiBox>
                <SortableList
                  onSortEnd={(oldIndex, newIndex) => onSortEnd(oldIndex, newIndex, "style_0")}
                  className="flex px-3 flex-wrap flex-col"
                  draggedItemClassName="bg-color-white"
                  distance={10}
                >
                  {featuredStyleList.map((p, index) => (
                    <SuiBox
                      key={index}
                      sx={{
                        width: "100%",
                      }}
                    >
                      <SortableItem
                        key={index}
                        style={{ width: "100%" }}
                        draggable={handle ? false : true}
                      >
                        <div
                          className="mx-2 my-2"
                          style={{
                            maxHeight: 360,
                            minHeight: 200,
                            overflow: "hidden",
                          }}
                        >
                          <ProductCard
                            index={index}
                            product={p}
                            imageOnly={true}
                            handleClick={handleClickItem}
                            editable={handle ? false : true}
                            slot="style_0"
                            handleRefresh={handleRefresh}
                            isOriginalSize
                            height="auto"
                            width="100%"
                            sx={{ maxHeight: 360 }}
                          />
                        </div>
                      </SortableItem>
                    </SuiBox>
                  ))}{" "}
                  {handle ? null : (
                    <SuiBox
                      sx={{
                        width: "100%",
                      }}
                    >
                      <SortableItem key={"add-image"} style={{ width: "100%" }}>
                        <div className="mx-2 my-2" draggable={false}>
                          <AddProductCard
                            slot="style_0"
                            handleRefresh={handleRefresh}
                            sx={{ height: 360 }}
                          />{" "}
                        </div>
                      </SortableItem>
                    </SuiBox>
                  )}
                </SortableList>
              </SuiBox>
            </SuiBox>
          )}
        </Grid>

        <Grid item xs={12} sm={7} md={7} lg={8} xl={9}>
          <SuiBox sx={{ px: 2 }}>
            <Profile userData={userData} handleRefresh={handleRefresh} slot="profile" />
            <SuiBox sx={{ px: 2, py: 2 }}>
              {handle ? null : (
                <SuiBox display="flex" justifyContent="space-between" sx={{ mb: 1 }}>
                  <SuiTypography variant="h5" fontWeight="medium" textTransform="capitalize">
                    Featured Collection
                  </SuiTypography>
                  <SuiButton variant="gradient" color="dark" onClick={handleShowImportCollection}>
                    Import Collection
                  </SuiButton>
                </SuiBox>
              )}
              <SortableList
                onSortEnd={(oldIndex, newIndex) => onSortEnd(oldIndex, newIndex, "col_0")}
                className="flex px-3 flex-wrap"
                draggedItemClassName="bg-color-white"
                distance={10}
              >
                {collectionStyleList.map((p, index) => (
                  <SuiBox
                    key={index}
                    sx={{
                      width: {
                        xs: "100%",
                        sm: "100%",
                        md: "50%",
                        lg: "33.33%",
                        xl: "25%",
                      },
                    }}
                  >
                    <SortableItem
                      key={index}
                      style={{ width: "100%" }}
                      draggable={handle ? false : true}
                    >
                      <div className="mx-2 my-2">
                        <ProductCard
                          index={index}
                          product={p}
                          imageOnly={false}
                          handleClick={handleClickItem}
                          editable={handle ? false : true}
                          slot="col_0"
                          handleRefresh={handleRefresh}
                          height={360}
                          sx={{ width: "100%", height: "auto" }}
                        />
                      </div>
                    </SortableItem>
                  </SuiBox>
                ))}{" "}
                {handle ? null : (
                  <SuiBox
                    sx={{
                      width: {
                        xs: "100%",
                        sm: "100%",
                        md: "50%",
                        lg: "33.33%",
                        xl: "25%",
                      },
                    }}
                  >
                    <SortableItem key={"add-image"} style={{ width: "100%" }}>
                      <div
                        className="mx-2 my-2"
                        draggable={false}
                        ondragstart={null}
                        style={{ height: "100%" }}
                      >
                        <AddProductCard
                          slot="col_0"
                          handleRefresh={handleRefresh}
                          sx={{ maxHeight: 360, height: "100%", minHeight: 200 }}
                          draggable={false}
                        />{" "}
                      </div>
                    </SortableItem>
                  </SuiBox>
                )}
              </SortableList>
            </SuiBox>
          </SuiBox>
        </Grid>
      </Grid>
      <Gallery />
    </div>
  );
};

export default Template1;
